/* eslint-disable @typescript-eslint/ban-ts-comment */
import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import { ChannelCallType, ChooseChannelCall } from './choose-channel-call'

const COMPONENT_ID = 'chooseChannelCall'

const showChooseChannelCall = (
  props: Parameters<typeof ChooseChannelCall>[0],
) => addModal({ id: COMPONENT_ID, props })

export const showChooseChannelCallDialog = (
  canMakeOnlineClass?: boolean,
): Promise<ChannelCallType> =>
  new Promise((resolve, reject) =>
    showChooseChannelCall({
      onConfirm: async callType => {
        await closeCurrentModal()
        resolve(callType)
      },
      onCancel: async () => {
        reject()
        await closeCurrentModal()
      },
      canMakeOnlineClass,
    }),
  )

export default {
  [COMPONENT_ID]: {
    Component: ChooseChannelCall,
  },
}
